"use strict";

// "use strict";

jQuery(function ($) {});